module.exports = __webpack_public_path__ + "static/img/5243_phase_function_Paper_PointsHejduk_Prediction.792a48d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5243_phase_function_Paper_PointsHejduk_Prediction.png
// module id = cgfK
// module chunks = 0